<template>
  <div>
    <div class="quiz-content">
      <h2>What is your gender?</h2>
    </div>
    <QuizSingleSelect
        :options="quizQuestions"
        @optChanged="onOptionChanged"
    />
  </div>
</template>

<script>

import { mapMutations } from 'vuex';
import QuizSingleSelect from "./QuizSingleSelect";
import swal from 'sweetalert';

export default {
  name: 'QuizGender',
  components: {
    QuizSingleSelect
  },

  data() {
    return {
      gender: '',
    };
  },

  computed: {
    quizQuestions() {
      return [{ option: "male", src: "male.png" }, { option: "female", src: "female.png" }];
    },
  },

  methods: {
    ...mapMutations( [
      'setStep',
      'setGender'
    ] ),

    nextQuiz() {
      if ( this.gender === '' ) {
        swal( "Warning!", "Please select your gender.", "warning" );
        return;
      }
      this.setStep( 1 );
      this.setGender( this.gender );
      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    onOptionChanged( option ) {
      this.gender = option;
      this.nextQuiz();
    },
  }
}
</script>